<template>
  <div class="revision-create">
    <b-form-group :label="'Descrição'" label-for="description">
      <b-form-input
        id="description"
        type="text"
        placeholder="Descrição da Revisão"
        v-model="model.description"
      />
    </b-form-group>

    <b-form-group :label="'Unidade de Medida'" label-for="unit">
      <b-form-select
        id="unit"
        v-model="model.measurementType"
        :options="units"
        placeholder="Selecione a unidade de medida"
        required
      ></b-form-select>
    </b-form-group>

    <b-form-group
      v-if="model.measurementType === 0"
      :label="'Quilometragem'"
      label-for="kilometers"
    >
      <b-form-input
        id="kilometers"
        type="number"
        placeholder="Quilometragem"
        v-model.number="model.kilometers"
      />
    </b-form-group>

    <b-form-group
      v-if="model.measurementType === 1"
      :label="'Horímetro'"
      label-for="horimeter"
    >
      <b-form-input
        id="horimeter"
        type="number"
        placeholder="Horímetro"
        v-model.number="model.horimeter"
      />
    </b-form-group>

    <b-form-group
      v-if="model.measurementType === 2"
      :label="'Dias'"
      label-for="days"
    >
      <b-form-input
        id="days"
        type="number"
        placeholder="Dias"
        v-model.number="model.days"
      />
    </b-form-group>

    <div class="d-flex justify-content-end mt-3">
      <b-button size="sm" @click="$emit('save')" :disabled="!isFormValid">
        Salvar Revisão
      </b-button>
      <b-button class="ml-2" size="sm" variant="danger" @click="$emit('hide')">
        Cancelar
      </b-button>
    </div>
  </div>
</template>

<script>
export default {
  name: "RevisionCreate",
  props: {
    model: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      units: [
        { value: null, text: "Selecione a unidade de medida" },
        { value: 0, text: "Quilômetros" },
        { value: 1, text: "Horas" },
        { value: 2, text: "Dias" }
      ]
    };
  },
  computed: {
    isFormValid() {
      switch (this.model.measurementType) {
        case 0:
          return this.model.kilometers != null && this.model.kilometers !== "";
        case 1:
          return this.model.horimeter != null && this.model.horimeter !== "";
        case 2:
          return this.model.days != null && this.model.days !== "";
        default:
          return false;
      }
    }
  },
  watch: {
    "model.measurementType"(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.model.kilometers = null;
        this.model.horimeter = null;
        this.model.days = null;
      }
    }
  }
};
</script>

<style scoped>
.revision-create {
  /* Adicione estilos personalizados aqui, se necessário */
}

.ml-2 {
  margin-left: 0.5rem;
}

.d-flex {
  display: flex;
}

.justify-content-end {
  justify-content: flex-end;
}

.mt-3 {
  margin-top: 1rem;
}
</style>
